﻿let _ = require('lodash');

module.exports = {

    headerSocialMediaButtonClick({ network }) {
        _gtmPush('header.socialButtonClicked', { network });
    },

    footerSocialMediaButtonClick({ network }) {
        _gtmPush('footer.socialButtonClicked', { network });
    },

    subscribeButtonClick() {
        _gtmPush('header.subscribeForm.opened');
    },

    subscribeFormSent() {
        _gtmPush('header.subscribeForm.submitted');
    },

    charityWatchdogsClick({ link }) {
        _gtmPush('footer.charityWatchDogsClicked', { link });
    },

    featuredDonorsClick({ page }) {
        _gtmPush('widget.featuredDonors.clicked', { page });
    },

    carouselClick({ imageIndex, targetURL, page}) {
        _gtmPush('homePage.carouselClicked', {
            imageIndex,
            targetURL,
            page
        });
    },

    donateTodayLevelSelected({ page, formId, donationAmount, preselectedAmoutChosen }) {
        _gtmPush('widget.donateToday.amoutClicked', {
            page,
            formId,
            donationAmount,
            preselectedAmoutChosen
        });
    },

    donateTodayNextClicked({ page, formId, donationAmount, preselectedAmoutChosen }) {
        _gtmPush('widget.donateToday.nextClicked', {
            page,
            formId,
            donationAmount,
            preselectedAmoutChosen
        });
    },

    donationFormAmountClicked({ formId, donationAmount, preselectedAmoutChosen }) {
        _gtmPush('donate.amountClicked', {
            formId,
            donationAmount,
            preselectedAmoutChosen
        });
    },

    donationFormDesignateGiftOpened({ formId }) {
        _gtmPush('donate.designatedGiftOpened', { formId });
    },

    donationFormDesignationChange({ formId, designate }) {
        _gtmPush('donate.designatedGiftSelected', { formId, designate });
    },

    donationFormHonorMemoryOfOpened({ formId }) {
        _gtmPush('donate.inHonorMemoryOpened', { formId });
    },

    donationFormHonorMemoryOfSubmit({ formId, inHonorSelected, inMemorySelected}) {
        _gtmPush('donate.inHonorMemorySubmitted', {
            formId,
            inHonorSelected,
            inMemorySelected
        });
    },

    donationFormCancelButtonClick({ formId, step }) {
        _gtmPush('donate.cancelClicked', { formId, step });
    },

    donationFormBackButtonClick({ formId, step }) {
        _gtmPush('donate.backClicked', { formId, step });
    },

    donationFormPaymentScreenOpen({
        formId,
        donationAmount,
        preselectedAmoutChosen,
        donationType,
        designate,
        inHonorSelected,
        inMemorySelected
    }) {
        _gtmPush('donate.paymentStarted', {
            formId,
            donationAmount,
            preselectedAmoutChosen,
            donationType,
            designate,
            inHonorSelected,
            inMemorySelected
        });
    },

    donationFormPaymentSuccess({
        formId,
        donationAmount,
        preselectedAmoutChosen,
        donationType,
        designate,
        inHonorSelected,
        inMemorySelected,
        ecommerce
    }) {
        _gtmPush('donate.paymentSuccessful', {
            formId,
            donationAmount,
            preselectedAmoutChosen,
            donationType,
            designate,
            inHonorSelected,
            inMemorySelected,
            'purchase.actionField.id':  ecommerce.purchase.actionField.id,
            'purchase.actionField.revenue':  ecommerce.purchase.actionField.revenue,
            'purchase.products.name': ecommerce.purchase.products[0].name,
            'purchase.products.price': ecommerce.purchase.products[0].price
        });
    },

    donationFormSocialButtonClick() {
        _gtmPush('thankYouPage.socialButtonClicked');
    },

    donationFormStartCampaignClick() {
        _gtmPush('thankYouPage.startACampaignButtonClicked');
    },

    donationFormPrintClick() {
        _gtmPush('thankYouPage.printClicked');
    },

    headerDonateByMailClick() {
        _gtmPush('donate.mailClicked', { position: 'header' });
    },

    formDonateByMailClick() {
        _gtmPush('donate.mailClicked', { position: 'belowForm' });
    },

    headerPhoneClick() {
        _gtmPush('donate.phoneClicked', {});
    },

    footerPhoneClick({ phoneNumber }) {
        _gtmPush('footer.phoneNumberClicked', { phoneNumber });
    },

    headerDonateClick({ page }) {
        _gtmPush('header.donateClicked', { page });
    },

    widgetOurWorkClick({ page }) {
        _gtmPush('widget.ourWork.clicked', { page });
    },

    widgetWaysToHelpClick({ page }) {
        _gtmPush('widget.waysToHelp.clicked', { page });
    },

    trackVirtualPageView({ virtualPath }) {
        _gtmPush('virtualPageView', {
            'virtualPageURL': virtualPath,
            'virtualPageTitle': virtualPath
        });
    },

    trackGenericEvent(eventName, params) {
        _gtmPush(eventName, params);
    }

    //trackVirtualPageView(path) {
    //    typeof ga == 'function' && ga('send', 'pageview', path);
    //    typeof hj == 'function' && hj('vpv', path);
    //}
}

function _gtmPush(event, eventParams) {
    dataLayer.push(_.assign({ event }, eventParams));
};